var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFingerprintIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M4.83907 15.442C4.85382 15.4171 4.86894 15.3924 4.88442 15.3678C6.01316 13.5734 6.66659 11.4515 6.66659 9.16667C6.66659 7.32572 8.15897 5.83333 9.99992 5.83333C11.8409 5.83333 13.3333 7.32572 13.3333 9.16667C13.3333 10.0142 13.2756 10.8488 13.1639 11.6667M11.3993 17.3697C11.9091 16.3522 12.327 15.2807 12.6423 14.1667M15.8414 15.11C16.3789 13.2214 16.6667 11.2276 16.6667 9.16667C16.6667 5.48477 13.6819 2.5 10 2.5C8.78571 2.5 7.64724 2.82465 6.66667 3.39188M2.5 12.8034C3.03388 11.7045 3.33333 10.4705 3.33333 9.16667C3.33333 7.95238 3.65798 6.81391 4.22521 5.83333M9.99989 9.16667C9.99989 12.0977 9.15924 14.8323 7.70589 17.1427",
    stroke: "#6941C6",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprintIcon);
export default __webpack_public_path__ + "static/media/fingerprintIcon.4812b4d5e73323b91b597c9a55367ac4.svg";
export { ForwardRef as ReactComponent };